import React from "react";
import { FormattedMessage } from "react-intl";
import { useHistory } from "react-router-dom";
import { Card, Row, Space, Badge } from "@masterteam/mt-design-react";

import DoughnutChart from "../../../DoughnutChart";

import useIsAr from "../../../../Hooks/useIsAr";

import { ReactComponent as LevelOneIcon } from "../../../../assets/images/level-one.svg";
import { ReactComponent as LevelTwoIcon } from "../../../../assets/images/level-two.svg";
import { ReactComponent as SupportiveIcon } from "../../../../assets/images/supportive-objective.svg";

import "./style.scss";

const ObjectiveCard = ({
  data,
  statuses,
  projectStatuses,
  width = "350px",
  isStrategic = true,
  initiativeStatus
}) => {
  const [isAr] = useIsAr();
  const history = useHistory();

  return (
    <Card
      className="objective-card cursor"
      style={{ width }}
      onClick={() => {
        const isDetailsModalExists = document.getElementById("detailsModal");

        if (!isDetailsModalExists)
          history.push(`/splus/objective-details/${data.ID}`);
      }}
    >
      <Row className="objective-card__title" justify="between" size="small">
        <Space align="center" className="text">
          {+data?.StrategyType === 2 ? (
            <SupportiveIcon fill={data?.ParentColor} />
          ) : +data?.Level === 1 ? (
            <LevelOneIcon fill={data?.ParentColor} />
          ) : (
            <LevelTwoIcon fill={data?.ParentColor} />
          )}
          <div> {isAr ? data?.ArabicName : data?.EnglishName}</div>
        </Space>

        <Badge
          size="small"
          color="#fff"
          className="code"
          backgroundColor={data?.ParentColor}
        >
          <div className="wrapper">
            <div>{data?.Code}</div>
          </div>
        </Badge>
      </Row>

      <div className="objective-card__charts">
        <Space direction="vertical" align="center">
          <DoughnutChart
            data={data?.KPIChart?.ChartData || []}
            statuses={statuses}
            count={data?.KPIChart?.Count}
            detailsTitle={"strategy-map.kpis-list"}
            detailsData={data?.KPIs || []}
            maxWidth="100px"
            textSize="16px"
            smallTooltip
            noClickEvent={!isStrategic}
          />

          <div className="doughnut-chart-title">
            <FormattedMessage id="common.kpis" />
          </div>
        </Space>

        <Space direction="vertical" align="center">
          <DoughnutChart
            data={data?.LevelChart?.ChartData || []}
            statuses={!isStrategic ? initiativeStatus: projectStatuses}
            count={data?.LevelChart?.Count}
            detailsTitle={"strategy-map.projects-list"}
            detailsData={data?.Levels || []}
            maxWidth="100px"
            textSize="16px"
            smallTooltip
            isProject
            noClickEvent={!isStrategic}
          />

          <div className="doughnut-chart-title">
            <FormattedMessage id={data?.StrategyType === 2 ? "common.strategic-initiatives" : "common.projects"} />
          </div>
        </Space>
      </div>
    </Card>
  );
};

export default ObjectiveCard;
